import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { Pwa } from './pwa.service';

export function initPromptEvent() {
  const pwa = inject(Pwa);
  return () => {
    pwa.init();
  };
}

export const APP_INITIALIZER_PROVIDERS: EnvironmentProviders[] = [
  provideAppInitializer(() => {
    const initializerFn = initPromptEvent();
    return initializerFn();
  }),
];
